import { GraphQLWebhookFleetRequester, webhookEventProductTypes, webhooksEventTypes } from '@cobliteam/api-lib/src/dashboard/webhooks';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

const graphQLWebhookFleetRequester = new GraphQLWebhookFleetRequester();

const FLEET_PRODUCT_TYPE_QUERY_KEY = 'webhook-fleet-product-type';

const useWebhookEventTypes = () => {
  const { data: fleetProductType } = useQuery<string | null>({
    queryKey: [FLEET_PRODUCT_TYPE_QUERY_KEY],
    queryFn: graphQLWebhookFleetRequester.getFleetProductType,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Number.POSITIVE_INFINITY,
  });

  const allowedEventTypes = useMemo(() => {
    if (!fleetProductType) return webhooksEventTypes;

    return webhooksEventTypes.filter((eventType) => {
      const supportedProducts = webhookEventProductTypes[eventType];
      if (!supportedProducts) return true;
      return supportedProducts.includes(fleetProductType);
    });
  }, [fleetProductType]);

  return allowedEventTypes;
};

export default useWebhookEventTypes;
